import { useEffect, useState } from "react";
import {
    Alert,
    Button, Card, CardBody, Chip,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader, Progress, Snippet, Table, TableBody, TableCell, TableColumn,
    TableHeader, TableRow, Skeleton,
    useDisclosure
} from "@heroui/react";
import {parseDatabaseDate} from "../../utils/general";
import {crearReclamo} from "../../services/reclamosService";
import {aprobarReclamo, financeApproveClaim} from "../../services/claimsService";
import { toast } from "sonner";
import {motion, AnimatePresence} from "framer-motion";
import {DetalleQuickview} from "../claim";
import { generateCopiableName } from "../../utils/general";

export default (params) => {
    const readOnlyClaims = params.readOnlyClaims || false;
    const canApproveCreate = params.canApproveCreate || false;
    const isFinanceUser = params.isFinanceUser || false;
    const isFinanceAllowed = params.isFinanceAllowed || false;
    const {isOpen, onOpen, onOpenChange} = useDisclosure();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState(new Set()); // ids selected
    const [tableData, setTableData] = useState([]); //datos de la tabla
    const [loading, setLoading] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [finished, setFinished] = useState(false);
    const [finalMessage, setFinalMessage] = useState(null);
    const [copied, setCopied] = useState(false);
    const gridApi = params.api

    const [view, setView] = useState("listado"); //variable para contenido del modal
    const [rskRef, setRskRef] = useState(null); //variable para enviar rskref a los otros contenidos del modal
    const [claimId, setClaimId] = useState(null);
    const [rowAprobado, setRowAprobado] = useState(null);
    const [claimData, setClaimData] = useState(null); // Estado para los datos del reclamo
    const [financeApproved, setFinanceApproved] = useState(false);
    const selectedStatuses = selectedRows.map((row) => row.status);
    const hasFinanceCheckSelected = selectedStatuses.some((status) => status === "Finance Check");
    const allSelectedReady = selectedStatuses.length > 0 && selectedStatuses.every((status) => status === "Ready to Claim");
    const currentStatus = claimData?.maestra?.status || selectedRows?.[0]?.status;
    const modalSelectionMode = isFinanceAllowed && !canApproveCreate ? "single" : "multiple";

    // Función para manejar cuando se carguen los datos del reclamo
    const handleClaimDataLoaded = (data) => {
        setClaimData(data);
        console.log("claimData", data);
        console.log("claimData.quickview_claim_survey?.claimamount", data?.quickview_claim_survey?.claimamount);
        console.log("claimData.maestra?.voyage_number", data?.maestra?.voyage_number);
    };


    useEffect(() => {
        if (!gridApi) return;

        const updateSelection = () => {
            const selected = gridApi.getSelectedRows(); // Obtiene filas seleccionadas
            setSelectedRows(selected);

            if (selected.length > 0) {
                const { embarcador, contraparte } = selected[0]; // Tomamos referencia del primero

                // Filtrar solo los que coincidan con embarcador y contraparte
                const filteredRows = getAllRows().filter(
                    (row) => row.embarcador === embarcador && row.contraparte === contraparte
                );

                setTableData(filteredRows); // Actualizar datos en la tabla del modal
                setSelectedKeys(new Set(selected.map(row => row.rsk_ref))); // setear ids seleccionados
            } else {
                setTableData([]); // Si no hay selección, limpiar tabla
            }
        };

        gridApi.addEventListener("selectionChanged", updateSelection);

        return () => {
            gridApi.removeEventListener("selectionChanged", updateSelection);
        };
    }, [gridApi]);


    const getAllRows = () => {
        if (!gridApi) return [];

        let allRows = [];
        gridApi.forEachNode((node) => {
            if (!node.group && node.data) { // Ignorar grupos
                allRows.push(node.data);
            }
        });
        return allRows;
    };

    useEffect(() => {
        setTableData(getAllRows());
    }, [gridApi]);

    const handleSelectionChange = (keys) => {
        // Normalizar keys a Set (NextUI puede entregar Set o string "all")
        const normalizedKeys = keys === "all" ? new Set() : (keys instanceof Set ? keys : new Set(keys));
        setSelectedKeys(normalizedKeys);

        if (!gridApi) return;

        gridApi.forEachNode((node) => {
            if (!node.group) { // Ignorar nodos de grupo
                node.setSelected(normalizedKeys.has(node.data.rsk_ref));
            }
        });
    };

    const getTotalReclamoUSD = () => {
        return selectedRows.reduce((total, row) => total + (Number(row.reclamo_usd) || 0), 0);
    };

    //Testing
    const selectRow = (rowId) => {
        gridApi.getRowNode(rowId).setSelected(true)
    }
    const deselectRow = (rowId) => {
        gridApi.getRowNode(rowId).setSelected(false)
    }

    const handleCrearReclamo = async () => {
        let crearReclamoIds = selectedRows.map(row => row.id)

        setLoading(true); //bloquear boton

        try {
            // SEND POST REQUEST
            const response = await crearReclamo(crearReclamoIds);

            // HANDLE RESPONSE
            if (response.status === 200) {
                const updatedData = response.data; // Si el servidor devuelve datos
                console.log("Actualización exitosa", updatedData);
                const reclamoURL = "https://quickview.rskgroupco.com/claimdetail?case=" + updatedData.updatedRows.uuid;
                const reclamoURLNew = 'https://quickview.rskgroupco.com/carrier';
                const uniqueCode = updatedData.updatedRows?.uniqueCode || "N/A";
                const uniqueCode1 = `
                    For your convenience, all claim-related documents and details are securely available online through our digital platform:
                    👉 https://quickview.rskgroupco.com/carrier
                    
                    To access this information, please use the unique access code: ${uniqueCode}.
                    
                    This is a secure and confidential portal hosted by RSK Group, designed to simplify the claim review process and ensure fast access to all supporting documentation.
                    
                    If you experience any issues accessing the platform, please contact us directly at: support@rskgroupco.com
                `;
                const uniqueCode2 = `${reclamoURLNew}`
                setFinalMessage(uniqueCode2)
                setFinished(true)
            } else {
                const errorText = response.statusText;
                console.error("Error en el servidor: ", errorText);
                alert("Error: " + errorText);
            }

        } catch (error) {
            console.error("Error al enviar la solicitud: ", error);
            alert("Error al conectar con el servidor.");
        } finally {
            setLoading(false);//desbloquear boton
        }
    }

    useEffect(() => {
        if (isOpen) {
            setFinished(false);
            setFinalMessage(null)
            setCopied(false);
            setClaimData(null); // Resetear datos del reclamo
            setFinanceApproved(false);
        }
    }, [isOpen]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(finalMessage);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Resetea el mensaje después de 2s
    };

    const handleClose = () => {
        setRskRef(null);
        setClaimId(null);
        setRowAprobado(null);
        setView("listado");

        if (onOpenChange) onOpenChange(false); // Necesitas cerrar el modal manualmente
    };

    // actualizar directamente "aprobado" a true usando gridApi
    const aprobarFilaPorId = (id, a_cargo = null) => {
        if (!gridApi) return;

        const rowNode = gridApi.getRowNode(id); // Busca la fila por su id
        if (rowNode) {
            // Actualiza el dato local de la fila
            rowNode.setData({
                ...rowNode.data,
                aprobado: true,
                a_cargo: a_cargo || rowNode.data.a_cargo // Mantener el valor existente si no se proporciona uno nuevo
            });
            console.log(`Fila con ID ${id} actualizada:`, rowNode.data);
        } else {
            console.warn(`No se encontró la fila con ID ${id}`);
        }
    };


    function handleAprobar() {
        //show reclamo uuid
        console.log("rowAprobado", rowAprobado)
        console.log("claimId", claimId)
        console.log("rskRef", rskRef)

        // Primero actualizar el estado local optimísticamente
        setTableData((prevTableData) => {
            console.log("Estado previo de tableData:", prevTableData);

            const updatedTableData = prevTableData.map((row) =>
                row.id === claimId
                    ? { ...row, aprobado: true }
                    : row
            );

            console.log("Estado actualizado de tableData:", updatedTableData);
            return updatedTableData;
        });

        // Actualizar AG-Grid optimísticamente (sin a_cargo por ahora)
        aprobarFilaPorId(claimId);

        setIsBusy(true);
        
        aprobarReclamo(claimId, true)
            .then((data) => {
                console.log("Registro actualizado exitosamente:", data);
                
                // Actualizar el campo a_cargo con la respuesta del backend
                if (data.a_cargo) {
                    setTableData((prevTableData) => {
                        const updatedTableData = prevTableData.map((row) =>
                            row.id === claimId
                                ? { ...row, a_cargo: data.a_cargo }
                                : row
                        );
                        return updatedTableData;
                    });

                    // Actualizar AG-Grid con el campo a_cargo
                    aprobarFilaPorId(claimId, data.a_cargo);

                    // Emitir evento personalizado para que DetalleQuickView pueda actualizarse
                    const aprobarEvent = new CustomEvent('reclamoAprobado', {
                        detail: {
                            rskRef: rskRef,
                            a_cargo: data.a_cargo
                        }
                    });
                    window.dispatchEvent(aprobarEvent);
                }
                
                setIsBusy(false);
                setRowAprobado(true);
                toast.success("Caso aprobado");
            })
            .catch((error) => {
                console.error("Error al actualizar el registro:", error);
                setIsBusy(false);
                toast.error("Error al aprobar el caso");
            });
    }

    const handleFinanceApprove = async () => {
        if (!claimId) return;
        setIsBusy(true);
        try {
            await financeApproveClaim(claimId);

            // Actualizar estados locales
            setTableData((prev) =>
                prev.map((row) => row.id === claimId ? { ...row, status: "Ready to Claim" } : row)
            );
            setSelectedRows((prev) =>
                prev.map((row) => row.id === claimId ? { ...row, status: "Ready to Claim" } : row)
            );
            setClaimData((prev) => prev ? { ...prev, maestra: { ...prev.maestra, status: "Ready to Claim" } } : prev);

            // Actualizar AG-Grid si es posible
            const rowNode = gridApi?.getRowNode?.(claimId);
            if (rowNode) {
                rowNode.setData({ ...rowNode.data, status: "Ready to Claim" });
            }

            toast.success("Caso aprobado financieramente y movido a Ready to Claim");
            setFinanceApproved(true);
        } catch (error) {
            console.error("Error en Finance Approve:", error);
            toast.error("Error al aprobar financieramente el caso");
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <>
            <div style={{ textAlign: "center" }}>
                <span>
                    <h2>
                        <i className="fa fa-calculator"></i> {params.title}
                    </h2>
                    <div style={{ fontSize: "large", padding: 10 }}>
                        <Button size="sm"
                            onPress={() => {
                                onOpen()
                                console.log("selected Rows", selectedRows.length)
                                console.log("all rows", getAllRows().length )
                                console.log("selectedRows", selectedRows.length)
                            }}
                            isDisabled={selectedRows.length === 0} // Desactiva si no hay selección
                            className={`p-2 rounded ${
                                selectedRows.length > 0 ? "bg-blue-500" : "bg-gray-300"
                            } text-white`}
                        >
                            Generar Reclamo de carga
                        </Button>
                    </div>
                    <h3>Filas seleccionadas: {selectedRows.length}</h3>
                    <dl>
                       {selectedRows.map((row, index) => (
                           <li key={index}>{row.rsk_ref || "Sin referencia"}</li>
                       ))}
                    </dl>
                </span>
            </div>

            <Modal
                isDismissable={false}
                isKeyboardDismissDisabled={true}
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                onClose={handleClose}
                size="full"
                scrollBehavior="inside"
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">
                                {view === "quickview" && !claimData ? (
                                    <div className="flex items-center gap-2">
                                        <span>Loading...</span>
                                        <Skeleton className="h-6 w-64 rounded-lg" />
                                    </div>
                                ) : view === "quickview" && claimData ? (
                                    <div className="flex flex-col gap-2">
                                        <span className="text-lg font-semibold">
                                            {/* Detalle del Reclamo:  */}
                                            {/* {claimTitle} */}
                                            {claimData && (
                                                <span className="ml-2">
                                                    {generateCopiableName(
                                                        claimData.quickview_claim?.rsk_ref || "N/A", 
                                                        claimData.quickview_claim?.exporter_name || "N/A", 
                                                        claimData.quickview_claim?.vessel || "N/A", 
                                                        claimData.maestra?.voyage_number || null, 
                                                        claimData.quickview_claim?.bl_awb || "N/A", 
                                                        claimData.quickview_claim?.container_number || "N/A", 
                                                        claimData.quickview_claim?.pol || "N/A", 
                                                        claimData.quickview_claim?.pod || "N/A", 
                                                        claimData.quickview_claim_survey?.claimamount || 0,
                                                        claimData.quickview_claim_survey?.claimamount || 0,
                                                        claimData.quickview_claim_survey?.selectedcurrency || "$"
                                                    )}
                                                </span>
                                            )}
                                            {claimData && (
                                                <button
                                                    onClick={() => {
                                                        const textToCopy = generateCopiableName(
                                                            claimData.quickview_claim?.rsk_ref || "N/A", 
                                                            claimData.quickview_claim?.exporter_name || "N/A", 
                                                            claimData.quickview_claim?.vessel || "N/A", 
                                                            claimData.maestra?.voyage_number || null, 
                                                            claimData.quickview_claim?.bl_awb || "N/A", 
                                                            claimData.quickview_claim?.container_number || "N/A", 
                                                            claimData.quickview_claim?.pol || "N/A", 
                                                            claimData.quickview_claim?.pod || "N/A", 
                                                            claimData.quickview_claim_survey?.claimamount || 0,
                                                            claimData.quickview_claim_survey?.claimamount || 0,
                                                            claimData.quickview_claim_survey?.selectedcurrency || "$"
                                                        );
                                                        //const textToCopy = `${claimTitle} / POL: ${claimData.quickview_claim?.pol || "N/A"} / POD: ${claimData.quickview_claim?.pod || "N/A"} / Claim Amount: $${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(claimData.quickview_claim_survey?.claimamount || 0)}`;
                                                        navigator.clipboard.writeText(textToCopy);
                                                    }}
                                                    className="ml-2 p-1 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors duration-200"
                                                    title="Copy to clipboard"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                                    </svg>
                                                </button>
                                            )}
                                        </span>
                                    </div>
                                ) : (
                                    "Generar reclamo de carga"
                                )}
                            </ModalHeader>
                            <ModalBody>
                                <AnimatePresence mode="wait">

                                    {view === "listado" && (
                                        <motion.div
                                            key="listado"
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: 10 }}
                                            transition={{ duration: 0.3 }}
                                        >

                                        <Table
                                            aria-label="Tabla de Reclamos"
                                            color="success"
                                            selectionMode={modalSelectionMode}
                                            selectedKeys={selectedKeys}
                                            onSelectionChange={handleSelectionChange}
                                            disallowEmptySelection
                                        >
                                            <TableHeader>
                                                <TableColumn>RSK Ref.</TableColumn>
                                                <TableColumn>Embarcador</TableColumn>
                                                <TableColumn>Contraparte</TableColumn>
                                                <TableColumn>Nave</TableColumn>
                                                <TableColumn>Container</TableColumn>
                                                <TableColumn>BL/AWB</TableColumn>
                                                <TableColumn>Fecha BL/AWB</TableColumn>
                                                <TableColumn>Reclamo USD</TableColumn>
                                                <TableColumn>Opciones</TableColumn>
                                            </TableHeader>
                                            <TableBody>
                                                {tableData.map((row) => (
                                                    <TableRow key={row.rsk_ref}>
                                                        <TableCell>{row.rsk_ref}</TableCell>
                                                        <TableCell>{row.embarcador}</TableCell>
                                                        <TableCell>{row.contraparte}</TableCell>
                                                        <TableCell>{row.nave}</TableCell>
                                                        <TableCell>{row.container}</TableCell>
                                                        <TableCell>{row.bl_awb} </TableCell>
                                                        <TableCell>{row.bl_awb_date ? parseDatabaseDate(row.bl_awb_date).toLocaleDateString("es-ES", { timeZone: "UTC" }) : "Sin fecha"}</TableCell>
                                                        <TableCell>${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.reclamo_usd || 0)} </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                color={row.aprobado ? "success" : "danger"}
                                                                size="sm"
                                                                onClick={() => {
                                                                    setRskRef(row.rsk_ref)
                                                                    setClaimId(row.id)
                                                                    setRowAprobado(row.aprobado)
                                                                    setView("quickview")
                                                                }}
                                                                role="button"
                                                                className="mb-1 mr-1"
                                                            >
                                                                {row.aprobado ? "Aprobado" : "Revisar"}
                                                            </Chip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <div className="flex flex-col gap-3">
                                            <p>Mostrando registros seleccionados y registros asociados</p>
                                        </div>

                                        <Card>
                                            <CardBody>
                                                <p>Total Reclamo USD: <strong>${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(getTotalReclamoUSD() || 0)}</strong></p>
                                            </CardBody>
                                        </Card>

                                        {finalMessage != null && (
                                            <div className="flex items-center justify-center w-full">
                                                <Alert
                                                    description={
                                                        <div className="flex justify-between items-center w-full">
                                                            <span>{finalMessage}</span>
                                                            <Snippet
                                                                size="sm"
                                                                hideSymbol
                                                                tooltipProps={{
                                                                    color: "foreground",
                                                                    content: "Copiar link",
                                                                    placement: "right",
                                                                    closeDelay: 0,
                                                                }}
                                                                codeString={finalMessage}
                                                            />
                                                        </div>
                                                    }
                                                    title="Se ha generado código para el reclamo:"
                                                />
                                            </div>
                                        )}
                                        </motion.div>
                                    )}

                                    {/* Loader mientras carga */}
                                    {loading && (
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ duration: 0.5 }}
                                        >
                                            <Progress isIndeterminate aria-label="Cargando..." className="max-w-full" size="sm" />
                                        </motion.div>
                                    )}

                                    {view === "quickview" && (
                                        <motion.div
                                            initial={{ opacity: 0, scale: 1 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{ duration: 0.3 }}
                                        >

                                            <DetalleQuickview
                                                rskRef={rskRef}
                                                approveView={true}
                                                claimId={claimId}
                                                isBusy={isBusy}
                                                setIsBusy={setIsBusy}
                                                rowAprobado={rowAprobado}
                                                onDataLoaded={handleClaimDataLoaded}
                                                readOnlyClaims={readOnlyClaims}
                                            />

                                        </motion.div>
                                    )}

                                </AnimatePresence>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    Cancelar
                                </Button>
                                {view !== "listado" && !readOnlyClaims && (canApproveCreate || params.isJefeJudicial) && currentStatus === "Ready to Claim" && (
                                    <>
                                        <Button color="primary" variant="light"
                                            onPress={() => {
                                                setView("listado");
                                                setRskRef(null);
                                                setClaimId(null);
                                                setRowAprobado(null);
                                            }}
                                        >
                                            Volver
                                        </Button>
                                        <Button
                                            color={rowAprobado ? "success" : "primary"}
                                            onPress={handleAprobar}
                                            isLoading={isBusy}
                                            isDisabled={rowAprobado}
                                        >
                                            {rowAprobado ? "Aprobado" : "Aprobar"}
                                        </Button>
                                    </>
                                )}
                                {view !== "listado" && isFinanceAllowed && currentStatus === "Finance Check" && (
                                    <Button
                                        color="primary"
                                        onPress={financeApproved ? onClose : handleFinanceApprove}
                                        isLoading={isBusy}
                                    >
                                        {financeApproved ? "Volver" : "Finance Approve"}
                                    </Button>
                                )}
                                {view === "listado" && !readOnlyClaims && (canApproveCreate || params.isJefeJudicial) && allSelectedReady && (
                                    <Button
                                        color="primary"
                                        isLoading={loading}
                                        onPress={finished ? onClose : handleCrearReclamo}
                                        isDisabled={
                                            tableData.length <= 0 ||
                                            ![...selectedKeys].every((rsk_ref) => {
                                                // Verifica que cada rsk_ref seleccionado corresponda a un elemento aprobado
                                                const item = tableData.find((item) => item.rsk_ref === rsk_ref); // Encuentra la fila correspondiente
                                                return item?.aprobado; // Comprueba si está aprobado
                                            })
                                        }
                                    >
                                        {finished ? "Cerrar" : "Crear Reclamo"}
                                    </Button>

                                )}

                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};